import { ref, get, set } from 'firebase/database';
import { database } from '../firebaseConfig';
import { findSameContactId } from './dedupe';
import { auth } from '../firebaseConfig';
import { getAccessible } from './recordAccess';
import { referralNotifyTitle, referralGiftTitle } from './pipelineContact';

// Referral follow-up TASKS only. Nothing is ever sent to the referrer.
const val = async (p) => (await get(ref(database, p))).val();
const today = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; };
const nameOf = (c) => [c && c.firstName, c && c.lastName].filter(Boolean).join(' ') || (c && c.name) || 'this client';

export const referrerNameFor = async (contact) => {
  if (!contact) return '';
  if (contact.referredById) { const r = await val(`crm/contacts/${contact.referredById}`); if (r) return nameOf(r); }
  return String(contact.referredByName || '').trim();
};

// Fixed task ids, so a task is never created twice (re-saving a record does nothing).
const addOnce = async (agent, taskId, task) => {
  if (!agent) return false;
  const path = `users/${agent}/tasks/${taskId}`;
  if (await val(path)) return false;
  const at = new Date().toISOString();
  await set(ref(database, path), { role: 'Agent', appliesTo: 'All', mode: 'task', type: 'Follow-up', status: 'pending', assignee: agent, dueDate: today(), createdAt: at, updatedAt: at, completedAt: null, notes: '', source: 'referral', ...task });
  return true;
};

// When a referred contact enters the pipeline: "Let [referrer] know you're working with [name]".
export const referralNotifyTask = async (kind, interest, contactId, contact, agent) => {
  const referrer = await referrerNameFor(contact);
  if (!referrer) return false;
  return addOnce(agent, `referral-notify-${interest.id}`, {
    name: referralNotifyTitle(referrer, nameOf(contact)), title: referralNotifyTitle(referrer, nameOf(contact)), crmContactId: contactId,
    crmContactName: nameOf(contact), ...(contact.referredById ? { referrerContactId: contact.referredById } : {}), [kind === 'buyer' ? 'buyerInterestId' : 'sellerInterestId']: interest.id,
  });
};

// When the deal goes under contract: "Send [referrer] a thank-you gift".
export const isUnderContract = (tx) => !!tx && (['pending', 'under-contract', 'closed'].includes(tx.status) || !!tx.underContract);
export const referralGiftTask = async (txId, tx) => {
  if (!txId || !isUnderContract(tx)) return false;
  // Admins can read every contact; others only the ones they own or that are shared with them.
  let contacts;
  try { contacts = (await val('crm/contacts')) || {}; } catch (e) { contacts = Object.fromEntries((await getAccessible('contacts', auth.currentUser && auth.currentUser.uid, false)).map(({ id, ...c }) => [id, c])); }
  let cid = tx.contactId && contacts[tx.contactId] ? tx.contactId : Object.keys(contacts).find((id) => contacts[id] && contacts[id].transactionIds && contacts[id].transactionIds[txId]);
  if (!cid) cid = findSameContactId({ phone: tx.phone, email: tx.email, firstName: tx.firstName, lastName: tx.lastName }, contacts);
  const c = cid && contacts[cid];
  const referrer = await referrerNameFor(c);
  if (!referrer) return false;
  return addOnce(tx.ownerUid || tx.createdBy || tx.agentUid, `referral-gift-${txId}`, {
    name: referralGiftTitle(referrer), title: referralGiftTitle(referrer), crmContactId: cid, crmContactName: nameOf(c), relatedTransactionId: txId,
    ...(c.referredById ? { referrerContactId: c.referredById } : {}),
  });
};
